type WaveRuleProps = {
  className?: string;
};

/** A short hand-drawn wave used instead of a plain horizontal rule. */
export function WaveRule({ className = "" }: WaveRuleProps) {
  return (
    <svg viewBox="0 0 120 12" className={`h-3 w-28 ${className}`} aria-hidden focusable="false">
      <path
        d="M2 8q7-6 14 0t14 0 14 0 14 0 14 0 14 0 14 0 14 0"
        fill="none"
        stroke="currentColor"
        strokeWidth="2"
        strokeLinecap="round"
        vectorEffect="non-scaling-stroke"
      />
    </svg>
  );
}
